<kendo-datepicker
  #picker
  class="app-dp"
  [value]="value"
  [format]="format"
  [formatPlaceholder]="'formatPattern'"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [disabledDates]="disabledDatesFn()"
  [calendarType]="'infinite'"
  [navigation]="true"
  [clearButton]="false"
  [showOtherMonthDays]="true"
  [popupSettings]="{ popupClass: 'app-dp-popup' }"
  [readOnlyInput]="readOnlyInput"
  (valueChange)="onValueChange($event)"
  (close)="onClose()"
  (click)="onHostClick($event, picker)"
  (keydown.enter)="onHostClick($event, picker)"
></kendo-datepicker>
